import { render, staticRenderFns } from "./CreateUpdateReporterModal.vue?vue&type=template&id=1c1097f3&scoped=true&"
import script from "./CreateUpdateReporterModal.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateReporterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1097f3",
  null
  
)

export default component.exports